import { render } from "./ModalBloquear.vue?vue&type=template&id=3299e51d"
import script from "./ModalBloquear.vue?vue&type=script&lang=js"
export * from "./ModalBloquear.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__